import { createSlice } from '@reduxjs/toolkit';

const transactionFormSlice = createSlice({
  name: 'transactionForm',
  initialState: {
    savedFormState: null, // Stores form data when navigating to add contact
  },
  reducers: {
    saveTransactionFormState: (state, action) => {
      state.savedFormState = action.payload;
    },
    clearTransactionFormState: (state) => {
      state.savedFormState = null;
    },
  },
});

export const { saveTransactionFormState, clearTransactionFormState } = transactionFormSlice.actions;

// Selectors
export const selectSavedTransactionFormState = (state) => state.transactionForm.savedFormState;

export default transactionFormSlice.reducer;
